export const environment = {
  production: false,
  version: '4.2.1',
  gitCommit: '15a9fb9',
  apiBaseUrl: '/api',
  staticBaseUrl: '/static',
  frontendUrl: '/',
  // Available models for selection
  // Bedrock models validated against eu-central-1 via AWS CLI (list-foundation-models)
  // INFERENCE_PROFILE → eu. prefix required; ON_DEMAND → no prefix
  modelOptions: [
    // OpenAI
    'gpt-4o-mini',
    'gpt-4.1-nano',
    'gpt-4.1-mini',
    'gpt-4.1',
    'gpt-4o',
    'gpt-5-mini',
    'gpt-5',
    // vLLM models
    'local/qwen3-32b',
    // Local AI models
    'ollama/devstral-32k:latest',
    'ollama/devstral:latest',
    'ollama/gemma3:27b',
    'ollama/glm-4.7-flash:latest',
    'ollama/qwen3:8b',
    'ollama/qwen3:14b',
    'ollama/qwen3-14b-32k:latest',
    'ollama/qwen3:32b',
    'ollama/qwen3-32b-fast:latest',
    'ollama/mistral-8k:latest',
    'ollama/llama3-8k:latest',
    // Bedrock — Claude 3 (ON_DEMAND)
    'bedrock/anthropic.claude-3-haiku-20240307-v1:0',
    'bedrock/anthropic.claude-3-sonnet-20240229-v1:0',
    // Bedrock — Claude 3.5+ (INFERENCE_PROFILE → eu./us. prefix)
    'bedrock/us.anthropic.claude-haiku-4-5-20251001-v1:0',
    'bedrock/eu.anthropic.claude-haiku-4-5-20251001-v1:0',
    'bedrock/eu.anthropic.claude-3-5-sonnet-20240620-v1:0',
    'bedrock/eu.anthropic.claude-3-7-sonnet-20250219-v1:0',
    'bedrock/eu.anthropic.claude-sonnet-4-20250514-v1:0',
    'bedrock/eu.anthropic.claude-sonnet-4-5-20250929-v1:0',
    // 'bedrock/eu.anthropic.claude-opus-4-5-20251101-v1:0',  // disabled — high cost
    'bedrock/eu.anthropic.claude-sonnet-4-6',
    // 'bedrock/eu.anthropic.claude-opus-4-6-v1',             // disabled — high cost
    // Claude 5 family. Sonnet 5 is enabled because it is cheaper than Sonnet
    // 4.6 ($2/$10 vs $3/$15) despite being newer; Opus stays disabled on cost,
    // consistent with 4.5 and 4.6 above.
    'bedrock/eu.anthropic.claude-sonnet-5',
    'bedrock/us.anthropic.claude-sonnet-5',
    // 'bedrock/eu.anthropic.claude-opus-5',                  // disabled — high cost
    // 'bedrock/us.anthropic.claude-opus-5',                  // disabled — high cost
    // Bedrock — Amazon Nova (INFERENCE_PROFILE → eu. prefix)
    'bedrock/eu.amazon.nova-micro-v1:0',
    'bedrock/eu.amazon.nova-lite-v1:0',
    'bedrock/eu.amazon.nova-2-lite-v1:0',
    'bedrock/eu.amazon.nova-pro-v1:0',
    // Bedrock — Meta Llama 3.2 (INFERENCE_PROFILE → eu. prefix)
    'bedrock/eu.meta.llama3-2-1b-instruct-v1:0',
    'bedrock/eu.meta.llama3-2-3b-instruct-v1:0',
    // Bedrock — Mistral (INFERENCE_PROFILE → eu. prefix)
    'bedrock/eu.mistral.pixtral-large-2502-v1:0',
    // Bedrock — Mistral Devstral (ON_DEMAND)
    'bedrock/mistral.devstral-2-123b',
    // Bedrock — ZAI GLM (ON_DEMAND)
    'bedrock/zai.glm-4.7-flash',
    // Bedrock — Qwen3 (ON_DEMAND)
    'bedrock/qwen.qwen3-32b-v1:0',
    'bedrock/qwen.qwen3-235b-a22b-2507-v1:0',
    // Disabled — not available in eu-central-1 (Meta geo-restriction):
    // 'bedrock/us.meta.llama4-scout-17b-instruct-v1:0',
    // 'bedrock/us.meta.llama4-maverick-17b-instruct-v1:0',
  ],
  // Model pricing in USD per 1M tokens [input, output].
  // Basis: eu-central-1 on-demand, regional (geo) inference profiles — the
  // region and profile kind the workers actually use. Mirrors KNOWN_PRICING in
  // scripts/update_model_pricing.py; keep the two in step.
  modelPricing: {
    'gpt-4o-mini':   { input: 0.15,  output: 0.60  },
    'gpt-4.1-nano':  { input: 0.10,  output: 0.40  },
    'gpt-4.1-mini':  { input: 0.40,  output: 1.60  },
    'gpt-4.1':       { input: 2.00,  output: 8.00  },
    'gpt-4o':        { input: 2.50,  output: 10.00 },
    'gpt-5-mini':    { input: 0.25,  output: 2.00  },
    'gpt-5':         { input: 1.25,  output: 10.00 },
    'gpt-5.4-mini':  { input: 0.75,  output: 4.50  },
    'gpt-5.4':       { input: 2.50,  output: 15.00 },
    'bedrock/anthropic.claude-3-haiku-20240307-v1:0':           { input: 0.25,  output: 1.25  },
    'bedrock/anthropic.claude-3-sonnet-20240229-v1:0':          { input: 3.00,  output: 15.00 },
    'bedrock/us.anthropic.claude-haiku-4-5-20251001-v1:0':      { input: 1.1, output: 5.5 },
    'bedrock/eu.anthropic.claude-3-5-sonnet-20240620-v1:0':     { input: 3.00,  output: 15.00 },
    'bedrock/eu.anthropic.claude-3-7-sonnet-20250219-v1:0':     { input: 3.00,  output: 15.00 },
    'bedrock/eu.anthropic.claude-sonnet-4-20250514-v1:0':       { input: 3.00,  output: 15.00 },
    'bedrock/eu.anthropic.claude-haiku-4-5-20251001-v1:0':      { input: 1.1, output: 5.5 },
    'bedrock/eu.anthropic.claude-sonnet-4-5-20250929-v1:0':     { input: 3.3, output: 16.5 },
    'bedrock/eu.anthropic.claude-opus-4-5-20251101-v1:0':       { input: 5.5, output: 27.5 },
    'bedrock/eu.anthropic.claude-sonnet-4-6':                   { input: 3.3, output: 16.5 },
    'bedrock/eu.anthropic.claude-opus-4-6-v1':                  { input: 5.5, output: 27.5 },
    'bedrock/eu.anthropic.claude-sonnet-5':                     { input: 2.2, output: 11.0 },
    'bedrock/us.anthropic.claude-sonnet-5':                     { input: 2.2, output: 11.0 },
    'bedrock/eu.anthropic.claude-opus-5':                       { input: 5.5, output: 27.5 },
    'bedrock/us.anthropic.claude-opus-5':                       { input: 5.5, output: 27.5 },
    'bedrock/eu.anthropic.claude-opus-4-8':                     { input: 5.5, output: 27.5 },
    'bedrock/us.anthropic.claude-opus-4-8':                     { input: 5.5, output: 27.5 },
    'bedrock/eu.anthropic.claude-opus-4-7':                     { input: 5.5, output: 27.5 },
    'bedrock/us.anthropic.claude-opus-4-7':                     { input: 5.5, output: 27.5 },
    'bedrock/eu.amazon.nova-micro-v1:0':                        { input: 0.046, output: 0.184 },
    'bedrock/eu.amazon.nova-lite-v1:0':                         { input: 0.078, output: 0.312 },
    'bedrock/eu.amazon.nova-2-lite-v1:0':                       { input: 0.429, output: 3.597 },
    'bedrock/eu.amazon.nova-pro-v1:0':                          { input: 1.05, output: 4.2 },
    'bedrock/eu.meta.llama3-2-1b-instruct-v1:0':                { input: 0.13, output: 0.13 },
    'bedrock/eu.meta.llama3-2-3b-instruct-v1:0':                { input: 0.19, output: 0.19 },
    'bedrock/eu.mistral.pixtral-large-2502-v1:0':               { input: 2.0, output: 6.0 },
    'bedrock/mistral.devstral-2-123b':                          { input: 0.48, output: 2.4 },
    'bedrock/zai.glm-4.7-flash':                                { input: 0.08, output: 0.48 },
    'bedrock/qwen.qwen3-32b-v1:0':                              { input: 0.2, output: 0.79 },
    'bedrock/qwen.qwen3-235b-a22b-2507-v1:0':                   { input: 0.29, output: 1.16 },
    'bedrock/us.deepseek.r1-v1:0':                              { input: 1.35,  output: 5.40  },
    'bedrock/deepseek.v3.2':                                    { input: 0.74, output: 2.22 },
  } as Record<string, { input: number; output: number }>
};
